// Normalize an email value for storage. Lowercase + trim, with empty/whitespace
// returning null (preserves the existing `email: form.email || null` convention
// at every INSERT site).
//
// Mirrors what migration 31's _normalize_sensitive_value does for emails on the
// SQL side, so storage is canonical regardless of write path (INSERT direct vs.
// UPDATE via try_set_sensitive_field RPC). Forward-only — no backfill of
// historical drift.
export const normalizeEmail = (val) => {
  const trimmed = (val || '').trim().toLowerCase()
  return trimmed || null
}
